export default {"src":"/_next/static/media/tab_ribbon.8c94c764.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};